// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Indent as RawIndent } from "lucide-react";
export const Indent = /* @__PURE__ */ createIcon(RawIndent, "Indent", 2);
